import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { signInUser } from "../Components/Utility/Auth";
import { CustomerGroup } from "../models/customerGroup.model";

const BASE_URL = process.env.REACT_APP_API_URL ?? "http://localhost:5001/api/";
const user = signInUser();

export const CustomerGroupApi = createApi({
  reducerPath: "CustomerGroupApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["CustomerGroup"],
  endpoints: (builder) => ({
    customerGroups: builder.query<CustomerGroup[], void>({
      query: () => {
        const u = signInUser();
        return `/customerGroup/${u?.aamarId || ""}`;
      },
      providesTags: ["CustomerGroup"],
    }),
    customerGroup: builder.query<CustomerGroup, string>({
      query: (_id) => `/customerGroup/customerGroup/${_id}`,
      providesTags: ["CustomerGroup"],
    }),
    addCustomerGroup: builder.mutation<CustomerGroup, CustomerGroup>({
      query: (newGroup) => ({
        url: "/customerGroup", // Matches the `/group` route in your backend
        method: "POST", // Matches the POST method in your backend
        body: newGroup, // Sends the `req.body` as expected by your backend
      }),
      invalidatesTags: ["CustomerGroup"], // Updates the cache when a new group is added
    }),
    addImportCustomerGroup: builder.mutation<{}, CustomerGroup>({
      query: (customerGroup) => ({
        url: "/customerGroup/import",
        method: "POST",
        body: customerGroup,
      }),
      invalidatesTags: ["CustomerGroup"],
    }),
    customerGroupList: builder.query<CustomerGroup[], any>({
      query: (aamarId) => `/customerGroup/list/${aamarId}`,
      providesTags: ["CustomerGroup"],
    }),

    customerGroupCount: builder.query<CustomerGroup[], any>({
      query: ({ aamarId }) => `/customerGroup/count/${aamarId}`,
      providesTags: ["CustomerGroup"],
    }),
    customerGroupById: builder.query<CustomerGroup, string>({
      query: (_id) => `/customerGroup/${_id}`,
      providesTags: ["CustomerGroup"],
    }),
    customerGroupPagination: builder.query<CustomerGroup, any>({
      query: ({ page, size, aamarId, q }) =>
        `/customerGroup/all/${page}/${size}/${aamarId}?q=${q}`,
      // query: ({page, size, q}) => `/Customer`,
      providesTags: ["CustomerGroup"],
    }),
    updateCustomerGroup: builder.mutation<void, CustomerGroup>({
      query: ({ _id, ...rest }) => {
        return {
          url: `/customerGroup/${_id}`,
          method: "PUT",
          body: rest,
        };
      },
      invalidatesTags: ["CustomerGroup"],
    }),

    customerGroupDw: builder.query<CustomerGroup, void>({
      query: () => {
        const u = signInUser();
        const a = u?.aamarId || "";
        const w = u?.warehouse || "allWh";
        return `/customerGroup/customerGroupDw/${a}/${w && w !== "undefined" ? w : "allWh"}`;
      },
      providesTags: ["CustomerGroup"],
    }),

    deleteCustomerGroup: builder.mutation<void, string>({
      query: (id) => ({
        url: `/customerGroup/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["CustomerGroup"],
    }),
  }),
});

export const {
  useCustomerGroupsQuery,
  useCustomerGroupQuery,
  useCustomerGroupListQuery,
  useCustomerGroupDwQuery,
  useCustomerGroupByIdQuery,
  useCustomerGroupPaginationQuery,
  useCustomerGroupCountQuery,
  useAddCustomerGroupMutation,
  useAddImportCustomerGroupMutation,
  useUpdateCustomerGroupMutation,
  useDeleteCustomerGroupMutation,
} = CustomerGroupApi;

export default CustomerGroupApi;
